import { FC, useEffect, useRef, useState } from 'react';

import { useAppDispatch } from '../../../../hook/useAppDispatch';
import { useAppSelector } from '../../../../hook/useAppSelector';

import { getDeviceList, setCurrentPage } from '../../../../store/slice/health-monitor/device-list';

import { FIRST_PAGE } from '../../../../constant/constants';

import arrowLeftActive from '../../../../assets/img/png/health-monitor/arrow-left-active.png';
import arrowLeftInactive from '../../../../assets/img/png/health-monitor/arrow-left-inactive.png';
import arrowRightActive from '../../../../assets/img/png/health-monitor/arrow-right-active.png';
import arrowRightInactive from '../../../../assets/img/png/health-monitor/arrow-right-inactive.png';

const PageNavigator: FC = () => {
  const [leftArrow, setLeftArrow] = useState(arrowLeftInactive);
  const [rightArrow, setRightArrow] = useState(arrowRightActive);
  const lastPage = useAppSelector((state) => state.deviceList.lastPage);
  const currentPage = useAppSelector((state) => state.deviceList.currentPage);
  const resultingPage = useAppSelector((state) => state.deviceList.resultingPage);
  const lastRequestedPage = useRef(currentPage);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (currentPage > FIRST_PAGE) {
      setLeftArrow(arrowLeftActive);
    } else {
      setLeftArrow(arrowLeftInactive);
    }

    if (currentPage === lastPage - 1) {
      setRightArrow(arrowRightInactive);
    } else {
      setRightArrow(arrowRightActive);
    }
  }, [currentPage, lastPage]);

  const handlePreviousPage = () => {
    if (currentPage > FIRST_PAGE) {
      const tempPageCount = currentPage - 1 < FIRST_PAGE ? FIRST_PAGE : currentPage - 1;
      dispatch(setCurrentPage(tempPageCount));
    }
  };

  const handleNextPage = () => {
    const tempPageCount = currentPage + 1;
    if (tempPageCount < lastPage) {
      dispatch(setCurrentPage(tempPageCount));
    }
  };

  useEffect(() => {
    if (lastRequestedPage.current !== currentPage) {
      dispatch(getDeviceList());
      lastRequestedPage.current = currentPage;
    }
  }, [currentPage, dispatch]);

  return (
    <span className="page">
      <span onClick={handlePreviousPage}>
        <img src={leftArrow} alt="arrowLeft"></img>
      </span>
      <span className="count">
        <span className="current_page">{`${resultingPage + 1}`}</span>
        <span>{` / ${lastPage}`}</span>
      </span>
      <span onClick={handleNextPage}>
        <img src={rightArrow} alt="arrowRight"></img>
      </span>
    </span>
  );
};

export default PageNavigator;
